import { render, staticRenderFns } from "./exam_question.vue?vue&type=template&id=03eb6abe&scoped=true&"
import script from "./exam_question.vue?vue&type=script&lang=js&"
export * from "./exam_question.vue?vue&type=script&lang=js&"
import style0 from "./exam_question.vue?vue&type=style&index=0&id=03eb6abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eb6abe",
  null
  
)

export default component.exports